import React from 'react';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const IconLlmArrowRightUp = React.forwardRef<SVGSVGElement, any>((props, ref) => {
  return (<svg enableBackground="new 0 0 24 24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" className="icon-llm-arrow-right-up" width="1em" height="1em" data-icon="icon-llm-arrow-right-up" aria-hidden="true" {...props} ref={ref}><path clipRule="evenodd" d="m22.9 0h-18.5v2.2h16.1l-20.5 20.2 1.6 1.6 20.4-20.2v15.7h2v-18.4c0-.6-.5-1.1-1.1-1.1z" fill="currentColor" fillRule="evenodd"/></svg>);
});

IconLlmArrowRightUp.displayName = 'IconLlmArrowRightUp';
